export default __webpack_public_path__ + "static/media/empty-archive-img.4eacea8a.svg";